// extracted by mini-css-extract-plugin
export var rankingTile = "jthV";